var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Stack } from "@fluentui/react";
import React, { useId, useState } from "react";
import { getResources } from "../../getResources";
import { EvolvedSettingsToggleIconButton } from "./Actions/EvolvedSettingsToggleIconButton";
import { getBasicSettingsStyle } from "./EvolvedSettingsDialog.styles";
// A Expando UX Component for the DMA Settings Work.
const EvolvedSettingsExpando = React.memo((_a) => {
    var { title, content, styles, buttonStyles, role, onInteracted, checked } = _a, rest = __rest(_a, ["title", "content", "styles", "buttonStyles", "role", "onInteracted", "checked"]);
    const id = "expando-" + useId();
    const [isExpanded, setExpanded] = useState(false);
    function onClick() {
        if (!!onInteracted) {
            onInteracted();
        }
        else {
            setExpanded(!isExpanded);
        }
    }
    return React.createElement(Stack, { id: id, styles: styles },
        React.createElement(Stack.Item, { styles: getBasicSettingsStyle() },
            React.createElement(EvolvedSettingsToggleIconButton, Object.assign({ styles: buttonStyles, role: role, title: title, checkedActionIconLabel: getResources().SettingsEvolvedDialog_Shared_ExpandButtonText, checkedActionIconName: "SegoeFluentChevronUp", uncheckedActionIconLabel: getResources().SettingsEvolvedDialog_Shared_CollapseButtonText, uncheckedActionIconName: "SegoeFluentChevronDown", checked: checked !== null && checked !== void 0 ? checked : isExpanded, callback: onClick }, rest))),
        (checked !== null && checked !== void 0 ? checked : isExpanded) && (React.createElement(Stack.Item, { styles: getBasicSettingsStyle() }, content)));
});
export default EvolvedSettingsExpando;
